module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAAAmJLR0QA/4ePzL8AAABnSURBVEjHY2AYVuA/EZD2BlAiPyQM+EWZAb8YAikzIJCYdIAfCDHkUmIAE8MJoIpOSlzgxfADqKaXfAMIGIFqAP4k3UkHA/B5oYeyQOwZwGikMCEFUJqUKc5MFGfnIVKkDWy9MEQBAL9ktnb9+HylAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons8-exit-64.png
// module id = aEva
// module chunks = 1